import { Button } from "@/components/ui/button";
import { GitBranch, Database, Shield } from "lucide-react";
import heroItOtBridge from "@/assets/hero-it-ot-bridge.jpg";

export function HeroSection() {
  return (
    <section className="relative min-h-[80vh] flex items-center justify-center bg-gradient-hero text-primary-foreground overflow-hidden">
      {/* Background Layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-transparent to-accent/20" />
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-30" 
        style={{ backgroundImage: `url(${heroItOtBridge})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-primary/60 via-primary/50 to-primary/70" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Less IT hassle. More OT control.
            <span className="text-accent block text-4xl md:text-5xl">One unified view of your entire network 🤝</span>
          </h1>
          
          {/* Alpha Status Badge - Centered */}
          <div className="flex justify-center mb-6">
            <div className="inline-flex flex-col items-center gap-2 px-6 py-3 rounded-full border-2 border-accent/50 bg-accent/10 backdrop-blur-sm">
              <span className="text-sm font-bold text-accent uppercase tracking-wider">
                ⚡ Alpha Version
              </span>
              <span className="text-xs text-primary-foreground/80">
                NIS2-ready network management • Beta testers wanted
              </span>
            </div>
          </div>
          
          <p className="text-xl md:text-2xl mb-8 text-primary-foreground/90 max-w-3xl mx-auto">
            ComplyManager gives OT engineers and IT teams one shared view of risks, controls, suppliers and assets – stay compliant and reduce drama.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button variant="hero" size="lg" className="text-lg px-8" asChild>
              <a href="/auth">Join Beta Program</a>
            </Button>
            <Button variant="outline" size="lg" className="text-lg px-8 bg-primary-foreground/10 border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/20">
              See How It Works
            </Button>
          </div>
          
          {/* Feature Highlights */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16">
            <div className="text-center">
              <GitBranch className="h-12 w-12 text-accent mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-2">One Source of Truth</h3>
              <p className="text-primary-foreground/80">No more version confusion. System layouts and asset relationships that IT and OT actually agree on.</p>
            </div>
            <div className="text-center">
              <Database className="h-12 w-12 text-accent mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-2">What's Connected to What?</h3>
              <p className="text-primary-foreground/80">Clear visibility into system relationships, dependencies, and connections – no guessing games.</p>
            </div>
            <div className="text-center">
              <Shield className="h-12 w-12 text-compliant mx-auto mb-4" />
              <h3 className="text-lg font-semibold mb-2">NIS2-Compliant Change Management</h3>
              <p className="text-primary-foreground/80">Track all system changes with audit trails. Built-in workflows that meet regulatory requirements.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}